module.exports = __webpack_public_path__ + "static/media/preview_user_referrals.33361783.png";